import { createSlice } from '@reduxjs/toolkit';
import { WebStorageClient } from "../clients/webStorage.client";
import { WEB_STORAGE_KEYS } from "../clients/clients.constants";

const initialFilters = {
  tag: {
    linked: false,
    unlinked: false,
    search: '',
    selectedEquipments: [],
    enabledEquipments: [],
  },
  equipment: {
    linked: false,
    unlinked: false,
    search: '',
    selectedEquipments: [],
    enabledEquipments: [],
  }
};

const initialState = WebStorageClient.getByKey(WEB_STORAGE_KEYS.EQUIPMENT_FILTERS) || initialFilters;

const equipmentFiltersSlice = createSlice({
  name: 'equipmentFilters',
  initialState,
  reducers: {
    setLinked(state, action) {
      if (action.payload.type === 'equipment' || action.payload.type === 'tag' ) {
        state[action.payload.type].linked = action.payload.value;
      }
    },
    setUnLinked(state, action) {
      if (action.payload.type === 'equipment' || action.payload.type === 'tag' ) {
        state[action.payload.type].unlinked = action.payload.value;
      }
    },
    setSearchEquipment(state, action) {
      if (action.payload.type === 'equipment' || action.payload.type === 'tag' ) {
        state[action.payload.type].search = action.payload.value;
      }
    },
    setSelectedEquipments(state, action) {
      if (action.payload.type === 'equipment' || action.payload.type === 'tag' ) {
        state[action.payload.type].selectedEquipments = action.payload.value;
      }
    },
    setEnabledEquipments(state, action) {
      if (action.payload.type === 'equipment' || action.payload.type === 'tag' ) {
        state[action.payload.type].enabledEquipments = action.payload.value;
      }
    },
    synchronizeEquipments(state, action) {
      const {type, validIds} = action.payload;
      if (type === 'equipment' || type === 'tag') {
        state[type].selectedEquipments = state[type].selectedEquipments.filter(id => validIds.includes(id));
        state[type].enabledEquipments = state[type].enabledEquipments.filter(id => validIds.includes(id));
      }
    }
  },
});

export const {
  setLinked,
  setUnLinked,
  setSearchEquipment,
  setSelectedEquipments,
  setEnabledEquipments,
  synchronizeEquipments
} = equipmentFiltersSlice.actions;

export default equipmentFiltersSlice.reducer;